import type { GetProductPointsRulesResponseType } from "@jti/fe-common";

export const calculateProductPoints = (rules: GetProductPointsRulesResponseType[], quantity: number): number => {
  return rules.reduce((prev, current) => {
    return prev + current.points * (current.multiply ? quantity : 1);
  }, 0);
};

export default calculateProductPoints;
